import * as _m0 from "protobufjs/minimal";
import { Long } from "../../helpers";
function createBaseGenesisState_InFlightPacketsEntry() {
  return {
    key: "",
    value: undefined
  };
}
export const GenesisState_InFlightPacketsEntry = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      InFlightPacket.encode(message.value, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState_InFlightPacketsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.key = reader.string();
          break;
        case 2:
          message.value = InFlightPacket.decode(reader, reader.uint32());
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$key;
    const message = createBaseGenesisState_InFlightPacketsEntry();
    message.key = (_object$key = object.key) !== null && _object$key !== void 0 ? _object$key : "";
    message.value = object.value !== undefined && object.value !== null ? InFlightPacket.fromPartial(object.value) : undefined;
    return message;
  }
};
function createBaseGenesisState() {
  return {
    params: undefined,
    inFlightPackets: {}
  };
}
export const GenesisState = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.params !== undefined) {
      Params.encode(message.params, writer.uint32(10).fork()).ldelim();
    }
    Object.entries(message.inFlightPackets).forEach(([key, value]) => {
      GenesisState_InFlightPacketsEntry.encode({
        key: key,
        value
      }, writer.uint32(18).fork()).ldelim();
    });
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGenesisState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.params = Params.decode(reader, reader.uint32());
          break;
        case 2:
          const entry2 = GenesisState_InFlightPacketsEntry.decode(reader, reader.uint32());
          if (entry2.value !== undefined) {
            message.inFlightPackets[entry2.key] = entry2.value;
          }
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$inFlightPacke;
    const message = createBaseGenesisState();
    message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
    message.inFlightPackets = Object.entries((_object$inFlightPacke = object.inFlightPackets) !== null && _object$inFlightPacke !== void 0 ? _object$inFlightPacke : {}).reduce((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InFlightPacket.fromPartial(value);
      }
      return acc;
    }, {});
    return message;
  }
};
function createBaseParams() {
  return {
    feePercentage: ""
  };
}
export const Params = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.feePercentage !== "") {
      writer.uint32(10).string(message.feePercentage);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseParams();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.feePercentage = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$feePercentage;
    const message = createBaseParams();
    message.feePercentage = (_object$feePercentage = object.feePercentage) !== null && _object$feePercentage !== void 0 ? _object$feePercentage : "";
    return message;
  }
};
function createBaseInFlightPacket() {
  return {
    originalSenderAddress: "",
    refundChannelId: "",
    refundPortId: "",
    packetSrcChannelId: "",
    packetSrcPortId: "",
    packetTimeoutTimestamp: Long.UZERO,
    packetTimeoutHeight: "",
    packetData: new Uint8Array(),
    refundSequence: Long.UZERO,
    retriesRemaining: 0,
    timeout: Long.UZERO,
    nonrefundable: false
  };
}
export const InFlightPacket = {
  encode(message, writer = _m0.Writer.create()) {
    if (message.originalSenderAddress !== "") {
      writer.uint32(10).string(message.originalSenderAddress);
    }
    if (message.refundChannelId !== "") {
      writer.uint32(18).string(message.refundChannelId);
    }
    if (message.refundPortId !== "") {
      writer.uint32(26).string(message.refundPortId);
    }
    if (message.packetSrcChannelId !== "") {
      writer.uint32(34).string(message.packetSrcChannelId);
    }
    if (message.packetSrcPortId !== "") {
      writer.uint32(42).string(message.packetSrcPortId);
    }
    if (!message.packetTimeoutTimestamp.isZero()) {
      writer.uint32(48).uint64(message.packetTimeoutTimestamp);
    }
    if (message.packetTimeoutHeight !== "") {
      writer.uint32(58).string(message.packetTimeoutHeight);
    }
    if (message.packetData.length !== 0) {
      writer.uint32(66).bytes(message.packetData);
    }
    if (!message.refundSequence.isZero()) {
      writer.uint32(72).uint64(message.refundSequence);
    }
    if (message.retriesRemaining !== 0) {
      writer.uint32(80).int32(message.retriesRemaining);
    }
    if (!message.timeout.isZero()) {
      writer.uint32(88).uint64(message.timeout);
    }
    if (message.nonrefundable === true) {
      writer.uint32(96).bool(message.nonrefundable);
    }
    return writer;
  },
  decode(input, length) {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInFlightPacket();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.originalSenderAddress = reader.string();
          break;
        case 2:
          message.refundChannelId = reader.string();
          break;
        case 3:
          message.refundPortId = reader.string();
          break;
        case 4:
          message.packetSrcChannelId = reader.string();
          break;
        case 5:
          message.packetSrcPortId = reader.string();
          break;
        case 6:
          message.packetTimeoutTimestamp = reader.uint64();
          break;
        case 7:
          message.packetTimeoutHeight = reader.string();
          break;
        case 8:
          message.packetData = reader.bytes();
          break;
        case 9:
          message.refundSequence = reader.uint64();
          break;
        case 10:
          message.retriesRemaining = reader.int32();
          break;
        case 11:
          message.timeout = reader.uint64();
          break;
        case 12:
          message.nonrefundable = reader.bool();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial(object) {
    var _object$originalSende, _object$refundChannel, _object$refundPortId, _object$packetSrcChan, _object$packetSrcPort, _object$packetTimeout, _object$packetData, _object$retriesRemain, _object$nonrefundable;
    const message = createBaseInFlightPacket();
    message.originalSenderAddress = (_object$originalSende = object.originalSenderAddress) !== null && _object$originalSende !== void 0 ? _object$originalSende : "";
    message.refundChannelId = (_object$refundChannel = object.refundChannelId) !== null && _object$refundChannel !== void 0 ? _object$refundChannel : "";
    message.refundPortId = (_object$refundPortId = object.refundPortId) !== null && _object$refundPortId !== void 0 ? _object$refundPortId : "";
    message.packetSrcChannelId = (_object$packetSrcChan = object.packetSrcChannelId) !== null && _object$packetSrcChan !== void 0 ? _object$packetSrcChan : "";
    message.packetSrcPortId = (_object$packetSrcPort = object.packetSrcPortId) !== null && _object$packetSrcPort !== void 0 ? _object$packetSrcPort : "";
    message.packetTimeoutTimestamp = object.packetTimeoutTimestamp !== undefined && object.packetTimeoutTimestamp !== null ? Long.fromValue(object.packetTimeoutTimestamp) : Long.UZERO;
    message.packetTimeoutHeight = (_object$packetTimeout = object.packetTimeoutHeight) !== null && _object$packetTimeout !== void 0 ? _object$packetTimeout : "";
    message.packetData = (_object$packetData = object.packetData) !== null && _object$packetData !== void 0 ? _object$packetData : new Uint8Array();
    message.refundSequence = object.refundSequence !== undefined && object.refundSequence !== null ? Long.fromValue(object.refundSequence) : Long.UZERO;
    message.retriesRemaining = (_object$retriesRemain = object.retriesRemaining) !== null && _object$retriesRemain !== void 0 ? _object$retriesRemain : 0;
    message.timeout = object.timeout !== undefined && object.timeout !== null ? Long.fromValue(object.timeout) : Long.UZERO;
    message.nonrefundable = (_object$nonrefundable = object.nonrefundable) !== null && _object$nonrefundable !== void 0 ? _object$nonrefundable : false;
    return message;
  }
};